import Page from "@/components/pages/inventory/sales-order/app/page";
import { createFileRoute } from "@tanstack/react-router";



export const Route = createFileRoute("/_app/inventory/sales-order/_modal/app")({
  component: Page,
});
